<template>
  <section class="text-center mb-20">
    <div class="max-w-4xl mx-auto">
      <!-- 标签 -->
      <div class="inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold transition-colors mb-6 bg-psychology-primary/10 text-psychology-primary border-psychology-primary/30">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="w-4 h-4 mr-2">
          <path d="M19 14c1.49-1.46 3-3.21 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.76 0-3 .5-4.5 2-1.5-1.5-2.74-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.3 1.5 4.05 3 5.5l7 7Z"></path>
        </svg>
        基于心理学研究的专业测评工具
      </div>

      <!-- 主标题 -->
      <h1 class="text-4xl md:text-6xl font-bold mb-6 gradient-text">
        恋爱占有欲指数计算器
      </h1>

      <!-- 描述 -->
      <p class="text-xl text-gray-600 mb-8 leading-relaxed max-w-3xl mx-auto">
        专业的恋爱心理评估工具，基于多个经过验证的心理测量量表，
        帮助您科学地了解自己或恋人的占有欲程度，促进健康和谐的亲密关系发展。
      </p>

      <!-- 双视角说明卡片 -->
      <div class="bg-psychology-primary/5 border border-psychology-primary/20 rounded-xl p-6 mb-8 max-w-3xl mx-auto shadow-sm">
        <div class="flex items-start gap-3">
          <div class="w-10 h-10 bg-psychology-primary/10 rounded-lg flex items-center justify-center flex-shrink-0">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="w-5 h-5 text-psychology-primary">
              <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"></path>
              <circle cx="9" cy="7" r="4"></circle>
              <path d="M22 21v-2a4 4 0 0 0-3-3.87"></path>
              <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
            </svg>
          </div>
          <div class="text-left">
            <h3 class="font-semibold text-psychology-primary mb-2">双视角智能评估</h3>
            <p class="text-sm text-gray-600 leading-relaxed">
              提供"给自己测"和"为恋人测"两种视角，系统会根据您的年龄、星座、恋爱状态等因素，
              提供个性化的分析结果和建议，帮助您更全面地认识恋爱关系中的占有欲特点。
            </p>
          </div>
        </div>
      </div>

      <!-- 主要按钮 -->
      <div class="flex flex-col sm:flex-row gap-4 justify-center items-center mb-12">
        <button @click="handleStartAssessment('self')" class="btn-primary text-lg">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="w-5 h-5">
            <path d="M19 14c1.49-1.46 3-3.21 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.76 0-3 .5-4.5 2-1.5-1.5-2.74-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.3 1.5 4.05 3 5.5l7 7Z"></path>
          </svg>
          给自己测
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="w-5 h-5">
            <path d="M5 12h14"></path>
            <path d="m12 5 7 7-7 7"></path>
          </svg>
        </button>
        <button @click="handleStartAssessment('partner')" class="btn-secondary text-lg">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="w-5 h-5">
            <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"></path>
            <circle cx="9" cy="7" r="4"></circle>
            <path d="M22 21v-2a4 4 0 0 0-3-3.87"></path>
            <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
          </svg>
          为恋人测
        </button>
      </div>

      <!-- 特色数据展示 -->
      <div class="grid grid-cols-2 md:grid-cols-4 gap-6 max-w-4xl mx-auto">
        <div class="text-center p-4 bg-white/80 backdrop-blur-sm rounded-xl border border-psychology-primary/10">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="w-8 h-8 text-psychology-primary mx-auto mb-2">
            <circle cx="12" cy="12" r="10"></circle>
            <polyline points="12 6 12 12 16 14"></polyline>
          </svg>
          <div class="text-2xl font-bold text-psychology-primary">10-15</div>
          <div class="text-sm text-gray-600">分钟完成</div>
        </div>
        <div class="text-center p-4 bg-white/80 backdrop-blur-sm rounded-xl border border-psychology-secondary/20 shadow-sm">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="w-8 h-8 text-psychology-secondary mx-auto mb-2">
            <path d="M3 3v16a2 2 0 0 0 2 2h16"></path>
            <path d="M18 17V9"></path>
            <path d="M13 17V5"></path>
            <path d="M8 17v-3"></path>
          </svg>
          <div class="text-2xl font-bold text-psychology-secondary">4</div>
          <div class="text-sm text-gray-600">核心维度</div>
        </div>
        <div class="text-center p-4 bg-white/80 backdrop-blur-sm rounded-xl border border-psychology-accent/20 shadow-sm">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="w-8 h-8 text-psychology-accent mx-auto mb-2">
            <path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"></path>
          </svg>
          <div class="text-2xl font-bold text-psychology-accent">100%</div>
          <div class="text-sm text-gray-600">隐私保护</div>
        </div>
        <div class="text-center p-4 bg-white/80 backdrop-blur-sm rounded-xl border border-psychology-success/20 shadow-sm">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="w-8 h-8 text-psychology-success mx-auto mb-2">
            <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"></path>
            <circle cx="9" cy="7" r="4"></circle>
            <path d="M22 21v-2a4 4 0 0 0-3-3.87"></path>
            <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
          </svg>
          <div class="text-2xl font-bold text-psychology-success">双视角</div>
          <div class="text-sm text-gray-600">深度分析</div>
        </div>
      </div>
    </div>

    <!-- 激活码验证对话框 -->
    <ActivationCodeDialog 
      :show="showActivationDialog"
      :target-route="targetRoute"
      @close="handleActivationClose"
    />
  </section>
</template>

<script>
import { isActivated } from '@/utils/activationUtils'
import ActivationCodeDialog from './ActivationCodeDialog.vue'

export default {
  name: 'HeroSection',
  components: {
    ActivationCodeDialog
  },
  data() {
    return {
      showActivationDialog: false,
      targetRoute: ''
    }
  },
  methods: {
    handleStartAssessment(type) {
      // 检查是否已激活
      if (isActivated()) {
        // 已激活，直接跳转
        this.$router.push(`/assessment/start?type=${type}`)
      } else {
        // 未激活，显示激活码对话框
        this.targetRoute = `/assessment/start?type=${type}`
        this.showActivationDialog = true
      }
    },
    
    handleActivationClose() {
      this.showActivationDialog = false
    }
  }
}
</script>

